import { observer } from 'mobx-react-lite'
import { Divider, Icon, Type, Typography } from 'shared/ui'
import { TimezoneContent } from 'shared/ui/Schedule/ui/TimezoneContent/TimezoneContent'
import { type CampaignDetailsModalStore } from 'widgets/CampaignDetailsModal/store/campaignDetailsModalStore'
import { MessageContent, SendFromContent } from 'widgets/DetailsContent'

import styles from './styles.module.scss'

export const Steps = observer(({ store }: { store: CampaignDetailsModalStore }) => {
  return (
    <div className={styles.wrap}>
      {store.steps.map((step, idx) => (
        <div key={step.id}>
          <div className={styles.titleWrap}>
            <div className={styles.stepBox}>
              <Typography ariaLabel={'counter'} variant={'body-md-medium'}>
                {step.order}
              </Typography>
            </div>
            <Typography
              ariaLabel={'stepTitle'}
              variant={'body-lg-medium'}
              ellipsis
              tooltipProps={{
                label: step.name,
              }}
            >
              {step.name}
            </Typography>
            <Type type={step.type} />
          </div>

          <MessageContent
            message={step.payload.message}
            attachments={step.attachments}
            type={step.type}
            isDetailsMode
          />
          <div className={styles.sendInfo}>
            <div className={styles.scheduleWrap}>
              <Typography
                ariaLabel={'scheduleLabel'}
                variant={'text-input-field-r'}
                color='var(--content-primary-tertiary)'
              >
                Send time
              </Typography>
              <div className={styles.value}>
                <Icon icon='schedule' color='var(--content-primary-tertiary)' fontSize={16} />
                <Typography
                  ariaLabel={'schedule'}
                  variant={'text-input-field-r'}
                  ellipsis
                  tooltipProps={{
                    label: step.scheduleStore.scheduleText,
                  }}
                >
                  {step.scheduleStore.scheduleText}
                </Typography>
                {step.scheduleStore.is_contact_timezone !== null && (
                  <TimezoneContent
                    is_contact_timezone={step.scheduleStore.is_contact_timezone}
                    isTertiary
                  />
                )}
              </div>
            </div>
            {!!step.sendFromInfo && <SendFromContent {...step.sendFromInfo} />}
          </div>
          {store.steps.length !== idx + 1 && (
            <Divider sx={{ marginBottom: '24px', marginTop: '24px' }} />
          )}
        </div>
      ))}
    </div>
  )
})
